import React from 'react';
import { Redirect, Switch, Route, useLocation, useRouteMatch } from 'react-router-dom';
import { BottomNavMenu, NotFoundPage } from 'components';
import { getLastUrlSegment } from 'utils/string';
import MainScreen from '../MainScreen';
import ScoreScreen from '../ScoreScreen';
import DecisionScreen from '../DecisionScreen';
import DecisionsScreen from '../DecisionsScreen';
import ReportScreen from '../ReportScreen';
import ReportEditScreen from '../ReportEditScreen';
import ObjectsScreen from '../ObjectsScreen';
import ObjectScreen from '../ObjectScreen';
import GuarantorsScreen from '../GuarantorsScreen';
import GuarantorScreen from '../GuarantorScreen';
import SdAnalyticsScreen from '../SdAnalyticsScreen';
import DebtorScreen from '../DebtorScreen';
import PropertyScreen from '../PropertyScreen';

import KFAnalyticsScreen from '../KFAnalyticsScreen';
import BeneficiariesScreen from '../BeneficiariesScreen';
import ContractsScreen from '../ContractsScreen';
import FsspScreen from '../FsspScreen';
import CompanyAffiliatesScreen from '../CompanyAffiliatesScreen';
import CasesScreen from '../CasesScreen';
import CaseScreen from '../CaseScreen';
import AccountingScreen from '../AccountingScreen';
import ChatScreen from '../ChatScreen';
import AttachmentsScreen from '../AttachmentsScreen';

import tabs from './AnketaScreen.mock';

const AnketaScreen = () => {
  const { path } = useRouteMatch();
  const { pathname } = useLocation();
  const activeTab = getLastUrlSegment(pathname);

  return (
    <>
      <Route path={[`${path}/main`, `${path}/chat`, `${path}/attachments`]} exact>
        <BottomNavMenu tabs={tabs} activeTab={activeTab} type="link" />
      </Route>
      <Switch>
        <Route path={`${path}/main`} exact>
          <MainScreen />
        </Route>
        <Route path={`${path}/main/score`} exact>
          <ScoreScreen />
        </Route>
        <Route path={`${path}/main/decisions`} exact>
          <DecisionsScreen />
        </Route>
        <Route path={`${path}/main/decisions/:decisionId`} exact>
          <DecisionScreen />
        </Route>
        <Route path={`${path}/main/sd-analytics`} exact>
          <SdAnalyticsScreen />
        </Route>
        <Route path={`${path}/main/sd-analytics/:debtorId`} exact>
          <DebtorScreen />
        </Route>
        <Route path={`${path}/main/sb-report`} exact>
          <ReportScreen />
        </Route>
        <Route path={`${path}/main/sb-report/edit`} exact>
          <ReportEditScreen />
        </Route>
        <Route path={`${path}/main/objects`} exact>
          <ObjectsScreen />
        </Route>
        <Route path={`${path}/main/objects/:objectId`} exact>
          <ObjectScreen />
        </Route>
        <Route path={`${path}/main/gp/guarantors/:guarantorId`} exact>
          <GuarantorScreen />
        </Route>
        <Route path={`${path}/main/gp/properties/:propertyId`} exact>
          <PropertyScreen />
        </Route>
        <Route path={`${path}/main/kf-analytics`} exact>
          <KFAnalyticsScreen />
        </Route>
        <Route path={`${path}/main/kf-analytics/beneficiaries`} exact>
          <BeneficiariesScreen />
        </Route>
        <Route path={`${path}/main/kf-analytics/contracts`} exact>
          <ContractsScreen />
        </Route>
        <Route path={`${path}/main/kf-analytics/fssp`} exact>
          <FsspScreen />
        </Route>
        <Route path={`${path}/main/kf-analytics/company-affiliates`} exact>
          <CompanyAffiliatesScreen />
        </Route>
        <Route path={`${path}/main/kf-analytics/cases`} exact>
          <CasesScreen />
        </Route>
        <Route path={`${path}/main/kf-analytics/cases/:caseId`} exact>
          <CaseScreen />
        </Route>
        <Route path={`${path}/main/kf-analytics/accounting`} exact>
          <AccountingScreen />
        </Route>
        <Route path={`${path}/chat`} exact>
          <ChatScreen />
        </Route>
        <Route path={`${path}/attachments`} exact>
          <AttachmentsScreen />
        </Route>
        <Switch>
          <Redirect from={`${path}/main/gp`} to={`${path}/main/gp/guarantors`} exact />
          <Route path={`${path}/main/gp`}>
            <GuarantorsScreen />
          </Route>
        </Switch>
        <Route>
          <NotFoundPage />
        </Route>
      </Switch>
    </>
  );
};

export default AnketaScreen;
